import React, { useEffect, useState, useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Navigation } from './components/navigation';
import { Header } from './components/header';
import { About } from './components/about';
import { Stats } from './components/stats';
import { Calculator } from './components/calculator';
import { Services } from './components/services';
import { Gallery } from './components/gallery';
import { Contact } from './components/contact';
import { SEO } from './components/seo';
import { QuoteModal } from './components/quote-modal';
import { FloatingContactButton } from './components/whatsapp-button';
import JsonData from './data/data.json';

const DEFAULT_LANG = 'bg';

const App = () => {
  const [language, setLanguage] = useState(() => {
    if (typeof window === 'undefined') return DEFAULT_LANG;
    const saved = window.localStorage.getItem('language');
    return saved === 'en' || saved === 'bg' ? saved : DEFAULT_LANG;
  });
  const [landingPageData, setLandingPageData] = useState(() => JsonData[language] || JsonData[DEFAULT_LANG]);
  const [quoteOpen, setQuoteOpen] = useState(false);

  useEffect(() => {
    setLandingPageData(JsonData[language] || JsonData[DEFAULT_LANG]);
  }, [language]);

  const switchLanguage = (lang) => {
    if (lang !== 'bg' && lang !== 'en') return;
    setLanguage(lang);
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('language', lang);
    }
  };

  const openQuote = useCallback(() => setQuoteOpen(true), []);
  const closeQuote = useCallback(() => setQuoteOpen(false), []);

  return (
    <Router>
      <SEO language={language} />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <a
                href="#za_nas"
                className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[60] focus:bg-ink focus:text-paper focus:px-4 focus:py-2"
              >
                {language === 'bg' ? 'Прескочи към съдържанието' : 'Skip to content'}
              </a>
              <Navigation
                data={landingPageData.Navigation}
                switchLanguage={switchLanguage}
                currentLanguage={language}
                onRequestQuote={openQuote}
                quoteLabel={landingPageData.Quote?.trigger}
              />
              <main>
                <Header
                  data={landingPageData.Header}
                  language={language}
                  onRequestQuote={openQuote}
                  quoteLabel={landingPageData.Quote?.trigger}
                />
                <Stats data={landingPageData.Stats} />
                <About data={landingPageData.About} language={language} />
                <Calculator
                  data={landingPageData.Calculator}
                  language={language}
                  onRequestQuote={openQuote}
                />
                <Services data={landingPageData.Services} language={language} />
                <Gallery data={landingPageData.Gallery} language={language} />
                <Contact data={landingPageData.Contact} language={language} />
              </main>
              <FloatingContactButton language={language} />
              <QuoteModal
                isOpen={quoteOpen}
                onClose={closeQuote}
                data={landingPageData.Quote}
                language={language}
              />
            </>
          }
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
};

export default App;
